<template>
   <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="data-card-main grid-layout">
            <div
              v-for="(obj, index) in computedInputsTypeElements"
              :key="index"
              :class="getClassesByTheElement(obj)"

            >
              <strong><label>{{ obj.label }}: </label></strong>
              <pre v-if="obj.name === 'message'" v-html="formatInJson(formatedValue(model[obj.name], obj))"></pre>
              <span v-else >{{ formatedValue(model[obj.name], obj) }}</span>
            </div>
          </q-card-section>
          <dynamic-compositions
            class="col-start-1 col-end-12"
            ref="compositions"
            :compositions-elm="formateInputsArray"
            :button-hidden="buttonHidden"
            @composition-button-click="actionButtonClickHandler"
          />
        </q-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtechDataTableUtils } from 'jtech-webcomps'
const {
  pageDetail
} = JtCrud
@Component({
  mixins: [pageDetail],
  name: 'UnsyncedMessageDetail',
  components: { pageDetail },
  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object
  }
})
class UnsyncedMessageDetail extends Vue {
  formatInJson (text) {
    return JSON.stringify(JSON.parse(text), null, 2)
  }

  get inputs () {
    return this.forms[0].inputs
  }

  get model () {
    return this.forms[0].dadosForm
  }

  get computedInputsTypeElements () {
    const inputs = this.formateInputsArray.length
      ? this.formateInputsArray.find((ci) => ci.type === 'input').elements
      : []
    return inputs.filter((input) => input.type != 'DATATABLE')
  }

  get computedCustomTypeElements () {
    return this.formateInputsArray.length
      ? this.formateInputsArray.find((ci) => ci.type === 'customElement')
        .elements
      : []
  }

  actionButtonClickHandler (button) {
    this.$emit('action-button', button.button, button.params, this)
  }

  formatedValue (value, element) {
    return JtechDataTableUtils.format.label(value, element)
  }

  getAlternateRowColor (element) {
    return (element.rowNumber || 0) % 2 ? 'row-grey' : ''
  }

  getClassesByTheElement (element) {
    return `${this.getColSpan(element)} ${this.getAlternateRowColor(element)}`
  }

  getColSpan (element) {
    return `col-start-${element.colIni} col-end-${element.colFin} `
  }
}
export default UnsyncedMessageDetail
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

for num in 1 .. 12 {
  .col-start-{num} {
    grid-column-start: num;
  }
}

for num in 1 .. 13 {
  .col-end-{num} {
    grid-column-end: num;
  }
}

.grid-layout {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-auto-rows: max-content;
}

.data-card-header {
  font-size: 1.3em;
  padding: 10px 17px 0px;
}

.data-card-main.q-card__section {
  height: calc(100% - 65px);
  overflow: hidden;
  padding: 15px 0;
}

.data-card-main.q-card__section > div {
  padding: 5px 12px;
}

.data-card-main.q-card__section > div > label {
  font-weight: bold;
}

.row-grey {
  background: $ice;
}

</style>
